export const locale = {
  lang: "ta",
  data: {
    NAV: {
      APPLICATIONS: "செயலி",
      SAMPLE: {
        TITLE: "Profile",
        BADGE: "0",
      },
      DASHBOARDS: "Kontrol Paneli",
      CALENDAR: "Takvim",
      ECOMMERCE: "E-Ticaret",
      ACADEMY: "Akademi",
      MAIL: {
        TITLE: "Posta",
        BADGE: "15",
      },
      MAIL_NGRX: {
        TITLE: "Posta Ngrx",
        BADGE: "13",
      },
      CHAT: "Sohbet",
      FILE_MANAGER: "Dosya Yöneticisi",
      CONTACTS: "Kişiler",
      TODO: "Yapılacaklar",
      SCRUMBOARD: "Proje",
    },
    "To Change Title": "பெயரை மாற்ற",
    "Please enter a valid name": "சரியான பெயரை உள்ளிடவும்",
    "Member Search Filter": "உறுப்பினர் தேடல் வடிகட்டி",
    "Choose any one of the below": "ஏதேனும் ஒன்றை தேர்வு செய்க",
    Bank: "வங்கி",
    "See More": "மேலும் பார்க்க",
    "Member Id is Not Found": "உறுப்பினர் எண் கிடைக்கவில்லை",
    "Please upload atleast one file": "குறைந்தபட்சம் ஒரு கோப்பைப் பதிவேற்றவும்",
    "File Size is Exceed, Please select a file below 2MB":
      "கோப்பு அளவு அதிகமாக உள்ளது, தயவுசெய்து 2MB க்கு கீழே உள்ள கோப்பைத் தேர்ந்தெடுக்கவும்",
    "Not in use": "பயன்பாட்டில் இல்லை",
    "To Add": "சேர்க்க",
    "To Edit": "திருத்த",
    Edit: "திருத்து ",
    "To Delete": "நீக்க",
    "Add New Account": "புதிய கணக்கைச் சேர்க்க",
    "New Bank Account Registration": "புதிய வங்கி கணக்கு பதிவு",
    "Account Holder Name": "கணக்கு வைத்திருப்பவரின் பெயர்",
    "Individual Account": "தனிநபர்",
    "Click here to view full details":
      "முழு விவரங்களையும் காண இங்கே கிளிக் செய்க",
    Maintainer: "நிர்வகிப்பவர்",
    "Joined Account or Not?": "இணைப்பு கணக்கா?",
    Alerts: "விழிப்பூட்டல்கள்",
    Welcome: "முகப்பு செய்திகள்",
    Notifications: "அறிவிப்புகள்",
    Message: "செய்திகள்",
    "All Alerts": "அனைத்தும்",
    "All types": "அனைத்து பிரிவுகள்",
    "Add New Alert": "புதிய விழிப்பூட்டலை சேர்க்க",
    "Audience Type": "பார்வையாளர் வகை",
    Audiences: "பார்வையாளர்கள்",
    "Add Audiences": "பார்வையாளர்களை சேர்க்க ",
    "Choose an option": "ஏதேனும் ஒன்றை தேர்வு செய்க",
    "New Alerts": "புதிய விழிப்பூட்டல்",
    "Edit Alerts": "விழிப்பூட்டல் திருத்தம்",
    "Alert Type": "விழிப்பூட்டல் வகை",
    "Choose Pages": "பக்கங்கள் தேர்வு",
    "Choose Party Posts": "பொறுப்புகள் தேர்வு",
    "Party Posts": "பொறுப்புகள்",
    "Party Post": "பொறுப்புகள்",
    "Date Range": "தேதி வரம்பு",
    "Date & Time": "தேதி மற்றும் நேரம்",
    "Message Description": "செய்தி விளக்கம்",
    "Event Time Duration": "நிகழ்வு கால அளவு",
    "Event Id": "நிகழ்வு எண்",
    "Event Start Time": "நிகழ்வு தொடங்கும் நேரம்",
    "Event End Time": "நிகழ்வு முடியும் நேரம்",
    "Resolution Added Successfully.": "தீர்மானம் சேர்க்கப்பட்டது.",
    "Resolution Adding Error.": "தீர்மானம் சேர்ப்பதில் பிழை.",

    "Please enter your secret number": "உங்கள் ரகசிய எண்ணை உள்ளீட்டு செய்யவும்",
    "Please register your secret number":
      "உங்கள் புதிய ரகசிய எண்ணை பதிவு செய்யவும்",
    "Should not be same number": "ஒரே எண்களாக இருக்க கூடாது",
    "Should not be continued number": "எண்கள் தொடர்ச்சியாக இருக்க கூடாது",
    Signin: "உள்நுழை",
    "Please Re-enter the pin again": "மீண்டும் ரகசிய எண்ணை பதிவு செய்யவும்",
    "Numbers are not matched": "எண்கள் பொருந்தவில்லை",
    "You have entered successfully": "நீங்கள் வெற்றிகரமாக நுழைந்தீர்கள்",
    "Pin registered successfully": "ரகசிய எண் வெற்றிகரமாக பதிவுசெய்யப்பட்டது",
    "You are blocked": "நீங்கள் தடை செய்யப்பட்டுள்ளீர்கள்",
    okay: "சரி",
    "Access to your account is prohibited, Please contact the seyarkalam":
      "உங்கள் பொறுப்புபக்கத்தை அணுக தடை செய்யப்பட்டுள்ளது, செயற்களத்தை தொடர்பு கொள்ளவும்.",
    "You have entered weak pin, try again":
      "ரகசிய எண் பலவீனமாக உள்ளது, மீண்டும் முயற்சிக்கவும்",
    "Pin registration failed, please try again":
      "ரகசிய எண் பதிவு தோல்வி, மீண்டும் முயற்சிக்கவும்",
    "You have entered wrong pin, ": "தவறான ரகசிய எண்ணை உள்ளிட்டுள்ளீர்கள் ",
    " attempts remaining": " முயற்சிகள் மீதமுள்ளன",
    hours: "மணி நேரம்",
    Appoinments: "நியமனங்கள்",
    "New Appoinment": "புதிய நியமனம்",
    "View More": "மேலும் பார்க்க",
    " days ": " நாட்கள் ",
    "time remaining": "மீதியுள்ளது நேரம்",
    consultation: "கலந்தாய்வு",
    "constituent consultation": "தொகுதி கலந்தாய்வு",
    "consultation meeting": "கலந்தாய்வு கூட்டம்",
    EXPIRED: "முடிந்தது",
    " hours ": " மணி ",
    " minutes ": " நிமிடங்கள் ",
    " seconds ": " விநாடிகள் ",
    "Choose Date": "தேதியைத் தேர்ந்தெடுக்கவும்",
    "Start Time": "தொடங்கும் நேரம்",
    "End Time": "முடியும் நேரம்",
    "Choose one": "தலைப்பைத் தேர்வுசெய்க",
    "Enter a month range": "மாத வரம்பை உள்ளிடவும்",
    "Enter a year range": "ஆண்டு வரம்பை உள்ளிடவும்",
    "Start time should be above 9.00 AM": "காலை 9.00 க்கு மேல் இருக்க வேண்டும்",
    "End time should be below 10.00 PM":
      "இரவு 10.00 மணிக்கு முன் இருக்க வேண்டும்",
    "Duration of the Appoinment should be 4 hours":
      "நியமனத்தின் கால அளவு சரியாக 4 மணி நேரம் இருக்க வேண்டும்",
    "*Start time should be above 9.00 AM and End time should be before 10.00 PM":
      "*தொடங்கும் நேரம் காலை 9.00 க்கு மேல் இருக்க வேண்டும் மற்றும் முடியும் நேரம் இரவு 10.00 மணிக்கு முன் இருக்க வேண்டும்",
    "Click to add extra 2 hours":
      "கூடுதல் 2 மணிநேரங்களைச் சேர்க்க கிளிக் செய்க",
    "New Appointment": "புதிய நியமனம்",
    "Edit Appointment": "நியமன திருத்தம்",
    "Are you sure want to delete it?":
      "இந்த நியமனத்தை நீக்க விரும்புகிறீர்களா?",
    Deleted: "நீக்கப்பட்டது",
    Admin: "நிர்வாகம்",
    Pages: "பக்கங்கள்",
    Page: "பக்கம்",
    "Enrolled By": "சேர்த்தவர்",
    "Enrolled On": "சேர்க்கப்பட்ட நாள்",
    Constituencies: "தொகுதிகள்",
    Constituency: "தொகுதி",
    LokshabaConstituency: "நாடாளுமன்றம்",
    Events: "நிகழ்வுகள்",
    District: "மாவட்டம்",
    district_name: "மாவட்டம்",
    Party_district: "கட்சி மாவட்டம்",
    "district id": "மாவட்டத்தின் எண்",
    "district name": "மாவட்டத்தின் பெயர் ",
    "Con Circle": "வட்டம்",
    Zone: "மண்டலம்",
    "Zone Id": "மண்டலம் எண்",
    "Zone Name": "மண்டலம் எண்",
    zone: "மண்டலம்",
    Members: "உறுப்பினர்கள்",
    Search: "தேடுக",
    Expenses: "செலவுகள்",
    Contributions: "பங்களிப்புகள்",
    "Contribution Id": "பங்களிப்பு எண்",
    Types: "பிரிவுகள்",
    Collections: "வசூல்கள்",
    Archives: "கடந்த மாதங்கள்",
    Date: "தேதி",
    Month: "மாதம்",
    Monthly: "மாதம் வாரியாக",
    "Add New": "புதியது",
    Submitted: "சமர்ப்பிக்கபட்டது",
    "Not Submitted": "சமர்பிக்கப்படவில்லை",
    Country: "நாடு",
    "Sub Types": "உட்பிரிவுகள்",
    Departments: "துறை",
    "Department Roles": "துறை பங்கு",
    User: "பயனர்",
    Circles: "வட்டங்கள்",
    Booths: "வாக்ககங்கள்",
    Pending_Branch_Posts: "நிலுவையில் உள்ள கிளை பொறுப்புகள்",
    Pending_Posts: "பரிந்துரைக்கப்பட்டவைகள்",
    Committed_Posts: "உறுதிப்படுத்தப்பட்டவைகள்",
    "booth number": "வாக்கக எண்",
    Graph: "வரைபடம்",
    "Circle Wise": "வட்டம் வாரியாக",
    "Constituency Wise": "தொகுதி வாரியாக",
    "Loksabha Constituency": "மக்களவை தொகுதி",
    Dashboard: "முகப்புப்பெட்டி",
    Add: "சேர்",
    "Add New Branch": "புதிய கிளை சேர்",
    Reset: "மீட்டமைக்க",
    "Constituency Name": "தொகுதி பெயர்",
    "Constituency Name (English)": "தொகுதி பெயர் (ஆங்கிலத்தில்)",
    "Circle Name": "ஒன்றியத்தின் பெயர்",
    "Branch Name": "கிளை பெயர்",
    "Constituency Id": "தொகுதி எண்",
    "Circle Index": "வட்ட குறியீட்டு",
    Role: "பங்கு",
    "Role Unique Id": "பங்கு தனித்தன்மை அடையாள எண்",
    Back: " பின்னால்",
    Name: "பெயர்",
    Contact: "தொடர்பு",
    "Download as PDF": "PDF ஆக பதிவிறக்கவும்",
    Download: "பதிவிறக்கவும்",
    Downloaded: "பதிவிறக்கம் செய்யப்பட்டது",
    "Downloading Error": "பதிவிறக்குவதில் பிழை",
    Update: "மேம்படுத்தல்",
    "Role Unique": "பங்கு தனித்தன்மை",
    Action: "நடவடிக்கை",
    Function: "செயல்பாடு",
    Applications: "விண்ணப்பங்கள்",
    No: "இல்லை",
    Id: "எண்",
    Area: "பகுதி",
    "member Id": "உறுப்பினர் எண்",
    "Member Id": "உறுப்பினர் எண்",
    "Plan Id": "திட்ட எண்",
    "Plan Name": "திட்டத்தின் பெயர்",
    "Event Title": "நிகழ்வு தலைப்பு",
    "Event Description": "நிகழ்வு  விளக்கம்",
    "Event Type": "நிகழ்வு பிரிவு",
    Organisers: "முன்னெடுத்தவர்கள்",
    "Add New Event": "புதிய நிகழ்வைச் சேர்க்கவும்",
    "Event Files": "நிகழ்வு கோப்புகள்",
    Uploaded: "பதிவேற்றிய",
    "Details View": "விவரம் காட்சி",
    "Expense Type": "செலவு பிரிவு",
    "Expense Title": "செலவு தலைப்பு",
    sponser: "தாளாளர்",
    Photo: "புகைப்படம்",
    "Login Access": "உள்நுழைவு அணுகல்",
    Access: "அணுகல்",
    "Access Controls": "அணுகல் கட்டுப்பாடுகள்",
    Password: "கடவுச்சொல்",
    "User Id": "பயனர் எண்",
    Generate: "உருவாக்கு",
    Contributor: "அளிப்பவர்",
    Amount: "தொகை",
    Total: "மொத்தம்",
    Circle: "வட்டாரம்",
    "Expense Files": "செலவு கோப்புகள்",
    Description: "விளக்கம்",
    Text: "உரை",
    "Booth No": "வா.சாவடி எண்",
    Move: "நகர்த்து",
    Close: "வெளியேறு",
    UnabletoaddwardPleaseentercorrectwardnumber:
      "வார்டு சேர்க்க முடியவில்லை. தயவு செய்து சரியான வார்டு எண்ணை உள்ளிடவும்.",
    Booth: "வா.சாவடி",
    Year: "ஆண்டு",
    Count: "எண்ணல்",
    "Total Voters": "மொத்த வாக்காளர்கள்",
    Cancel: "ரத்து",
    ok: "சரி",
    Structure: "கட்டமைப்பு",
    "Add New User": "புதிய பயனரைச் சேர்க்கவும்",
    "Reset UserID": "பயனர் மீட்டமைக்கவும்",
    "Departments & Role": "துறைகள் மற்றும் பங்கு",
    "Update User": "புதுப்பிப்பு பயனர்",
    " My Profile": " எனது பக்கம்",
    "Sign Out": "வெளியேறு",
    "Booth Id": "வா.சாவடி எண்",
    "Edit Booth": "திருத்து வா.சாவடி",
    "Select Booth": "வா.சாவடி தேர்ந்தெடுக்கவும்",
    "Select Branchs": "கிளைகள் தேர்ந்தெடுக்கவும்",
    "Select Branch": "கிளையை தேர்ந்தெடுக்கவும்",
    "Select Group": "குழுவை தேர்ந்தெடுக்கவும்",
    "Select SubGroup": "துணைக்குழுவை தேர்ந்தெடுக்கவும்",
    "Select Constituency & Circle":
      "தொகுதி மற்றும் வட்டத்தைத் தேர்ந்தெடுக்கவும்",
    "Reset MemberID": "உறுப்பினரை மீட்டமைக்கவும்",
    "Edit Member": "திருத்து உறுப்பினர்",
    "All Members": "அனைத்து உறுப்பினர்கள்",
    "Events By": "மூலம் நிகழ்வு",
    "Which date should you copy?": "எந்த தேதியை நீங்கள் நகலெடுக்க வேண்டும்?",
    Copy: "நகல்",
    "Not paid": "செலுத்தப்படவில்லை",
    Paid: "செலுத்தியது",
    "Edit Contribution": "பங்களிப்பைத் திருத்து",
    "Sort By": "வரிசை படுத்துக",
    "Expense Description(Optional)": "செலவு விளக்கம்(கட்டாயமற்ற)",
    "Add New Expense": "புதிய செலவைச் சேர்க்கவும்",
    "Edit Expense": "செலவைத் திருத்து",
    "Note: You can only download submitted events only":
      "குறிப்பு: சமர்பிக்கப்பட்ட நிகழ்வுகள் மட்டுமே பதவிறக்கம் செய்ய முடியும்.",
    "Which union do you want to move?":
      "எந்த யூனியனை நகர்த்த விரும்புகிறீர்கள்?",
    History: "முந்தைய பதிவுகள்",
    "Year & Count": "ஆண்டு & எண்ணிக்கை",
    select: "தேர்ந்தெடு",
    "Select All": "அனைத்தையும் தேர்ந்தெடுக்க",
    "Select Any One": "ஏதேனும் ஒன்றைத் தேர்ந்தெடுக்கவும்",
    "Display Deactivate Circles": "செயலில் இல்லாத வட்டங்களைக் காண்பி",
    Deactivate: "செயலிழக்கச் செய்",
    "Select District": "மாவட்டத்தைத் தேர்ந்தெடுக்கவும்",
    "Select Zone": "மண்டலத்தைத் தேர்ந்தெடுக்கவும்",
    "Select Constituency": "தொகுதியைத் தேர்ந்தெடுக்கவும்",
    "Select Const Circle": "ஒன்றியத்தை தேர்ந்தெடுக்கவும்",
    "Select Cons Circle": "பகுதியைத் தேர்ந்தெடுக்கவும்",
    "Select Circle": "வட்டத்தைத் தேர்ந்தெடுக்கவும்",
    "Add New Contribution": "புதிய பங்களிப்பைச் சேர்க்கவும்",
    "Obtained via Development Team?": "மேம்பாட்டு குழு வழியாகப் பெறபட்டதா?",
    "Edit contribution": "பங்களிப்பைத் திருத்து",
    "Edit Event": "நிகழ்வைத் திருத்து",
    "Contact (Optional)": "தொடர்பு (கட்டாயமற்ற)",
    "Member Id (Optional)": "உறுப்பினர் அடையாள எண் (கட்டாயமற்ற)",
    "Sponser Details": "ஆதரவாளர் விவரங்கள்",
    "Files (maximum 2) < 5MB": "கோப்புகள் (அதிகப்பட்சம் 2) < 5MB",
    "Receipt Number": "ரசீது எண்",
    January: "ஜனவரி",
    February: "பிப்ரவரி",
    March: "மார்ச்",
    April: "ஏப்ரல்",
    May: "மே",
    June: "ஜூன்",
    July: "ஜூலை",
    August: "ஆகஸ்ட்",
    September: "செப்டம்பர்",
    October: "அக்டோபர்",
    November: "நவம்பர்",
    December: "டிசம்பர்",
    Development: "மேம்பாடு",
    "Add New Member": "புதிய உறுப்பினர்கள் சேர்க்கவும்",
    Import: "இறக்குமதி",
    "Address (Optional)": "முகவரி (கட்டாயமற்ற)",
    "Joining Date": "சேரும் தேதி",
    "Email (Optional)": "மின்னஞ்சல் (கட்டாயமற்ற)",
    "Photo (Optional)": "புகைப்படம் (கட்டாயமற்ற)",
    "Circle (Optional)": "வட்டம் (கட்டாயமற்ற)",
    "Booth (Optional)": "வா.சாவடி (கட்டாயமற்ற)",
    "Pincode (Optional)": "அஞ்சல் குறியீடு (கட்டாயமற்ற)",
    "By Booth": "வா.சாவடி",
    "By Circle": "பகுதி வாரியாக",
    "By Role Name": "பொறுப்பு வாரியாக",
    Address: "முகவரி",
    "District Councilor Wards": "மாவட்ட கவுன்சிலர் சிறகங்கள்(வார்டுகள்)",
    Panchayat: "ஊராட்சி",
    Interested: "விருப்பப்பட்டவர்கள்",
    Competed: "போட்டியிட்டவர்",
    Wards: "சிறகங்கள்(வார்டுகள்)",
    Ward: "சிறகம்(வார்டு)",
    "Add Ward": "வார்டைச் சேர்க்கவும்",
    "Ward Index": "சிறகம்(வார்டு)அட்டவணை",
    "Ward No": "சிறகம்(வார்டு)எண் ",
    "Ward Name": "சிறகம்(வார்டு)பெயர்",
    Active: "செயலில் உள்ளது",
    Inactive: "செயலில் இல்லை",
    BarrackRestrictions: "பேராக் கட்டுப்பாடுகள்",
    RoleRestrictions: "பங்கு கட்டுப்பாடுகள்",
    Edit_the_Subgroup: "துணைக்குழுவை மாற்ற",
    "Add Interested People": "ஆர்வமுள்ளவர்களைச் சேர்க்கவும்",
    "Election Date": "தேர்தல் தேதி",
    "Nomination Status": "விருப்பமனு நிலவரம்",
    Opponents: "எதிரணிகள்",
    Opponent: "எதிர்ப்பவர்",
    Supporter: "ஆதரிப்பவர்",
    "Proposed Election Date": "முன்மொழியப்பட்ட தேர்தல் தேதி",
    Election: "தேர்தல்",
    Application: "விருப்ப மனு",
    Panchayats: "ஊராட்சிகள்",
    "Add Panchayat": "ஊராட்சி மன்றம் சேர்க்கவும்",
    "Panchayat Index": "ஊராட்சி மன்ற வ.எண்",
    "Panchayat Name": "ஊராட்சி மன்றம் பெயர்",
    Posts: "பதவிகள்",
    "Assembly Structure": "சட்டமன்ற கட்டமைப்பு",
    "Local Structure": "உள்ளாட்சி கட்டமைப்பு ",
    "Election Details": "தேர்தல் விவரங்கள்",
    "Party Responsible": "கட்சி பொறுப்பாளர்கள்",
    "Barrack Responsible": "பாசறை பொறுப்பாளர்கள்",
    "Member Details": "உறுப்பினர் விவரங்கள்",
    "Union List": "தொகுதி உட்பிரிவுகள்",
    "Add Union": "உட்பிரிவுகளை சேர்க்கவும்",
    "Add Booth": "வா.சாவடியை சேர்க்கவும்",
    "Add Section": "பகுதியை சேர்க்கவும்",
    "All Sections": "அனைத்து பகுதிகள்",
    "Section Index": "பகுதி எண்",
    "Section Name": "பகுதி பெயர்",
    "Rural Panchayats": "கிராம ஊராட்சி மன்றங்கள்",
    "Village union councils": "கிராம ஒன்றியக்குழு சபைகள்",
    "District Panchayat Board": "மாவட்ட ஊராட்சி சபை",
    Municipalities: "நகராட்சிகள்",
    "Town Panchayats": "பேரூராட்சிகள்",
    Corporations: "மாநகராட்சிகள்",
    "Add Municipality": "நகராட்சியைச் சேர்க்க",
    "Add Town Panchayats": "பேரூராட்சி சேர்க்க",
    "Add Corporations": "மாநகராட்சி சேர்க்க",
    "Add Rural Panchayat": "கிராம ஊராட்சி மன்றம் சேர்க்கவும்",
    "Add Village Union Council": "கிராமம் ஒன்றிய கவுன்சில் சேர்க்கவும்",
    Elections: "தேர்தல்",
    "Union Council Wards": "ஒன்றியக்குழு சபை சிறகங்கள்(வார்டுகள்)",
    "Municipal Wards": "நகராட்சி சிறகங்கள்(வார்டுகள்)",
    "Town Panchayat Wards": "பேரூராட்சி சிறகங்கள்(வார்டுகள்)",
    "Corporation Wards": "மாமன்ற சிறகங்கள்(வார்டுகள்)",
    "District Panchayat Wards": "மாவட்ட சபை சிறகங்கள்(வார்டுகள்)",
    "District Panchayat Ward": "மாவட்ட சபை சிறகம்(வார்டு)",
    Unions: "ஒன்றியங்கள் ",
    "Is this union shared with other district council wards?":
      "இந்த ஒன்றியம் மற்ற மாவட்ட சபை சிறகங்களுடன்(வார்டுடன்) பகிரப்படுகிறதா?",
    "Booth ID (ASC)": "வா.சாவடி எண் (ஏறு வரிசை)",
    "Booth ID (DESC)": "வா.சாவடி எண் (இறங்கு வரிசை)",
    "Constituency Details": "தொகுதி விவரங்கள்",
    "District Details": "மாவட்ட விவரங்கள்",
    "Loksabha Details": "மக்களவை விவரங்கள்",
    "Zone Details": "கட்சி மாவட்ட விவரங்கள்",
    "No of Events": "நிகழ்வு எண்ணிக்கை",
    "No of members": "உறுப்பினர் எண்ணிக்கை",
    Assigned: "ஒதுக்கப்பட்டவைகள்",
    Unassigned: "ஒதுக்கப்படாதவைகள்",
    "Union Ward": "ஒன்றியக்குழு சிறகம்(வார்டு)",
    "Select Options": "விருப்பங்களை தேர்ந்தெடுக்கவும்",
    "Indirect Election": "மறைமுக தேர்தல்",
    "Direct Election": "நேரடி தேர்தல்",
    "Election Category": "தேர்தல் வகை",
    "Election Type": "தேர்தல் வகை",
    Union: "ஒன்றியம்",
    Municipal: "நகராட்சி",
    "Municipal Sections": "நகராட்சி பகுதிகள்",
    Corporation: "மாநகராட்சி",
    "Corporation Sections": "மாநகராட்சி பகுதிகள்",
    "Town Panchayat": "பேரூராட்சி",
    "Election Actual Date": "தேர்தல் நடந்த நாள்",
    "Nomination Start Date": "வேட்புமனு ஆரம்ப நாள்",
    "Nomination End Date": "வேட்புமனு இறுதி நாள்",
    "Winning Status": "தேர்தல் முடிவு",
    "Lok Sabha Constituencies": "நாடாளுமன்றம்",
    "For Uploads": "பதிவேற்றங்களுக்கு",
    Uploads: "பதிவேற்றங்கள்",
    "District union list": "மாவட்ட ஒன்றிய-நகர பட்டியல்",
    "Imports Report": "இறக்குமதி அறிக்கை",
    Self: "நாம் தமிழர்",
    "Opp 1": "எதிரணி 1",
    "Opp 2": "எதிரணி 2",
    Profile: "சுயவிவரம்",
    "Member Page": "உறுப்பினர் பக்கம்",
    "Party responsibilities": "கட்சி பொறுப்புகள்",
    "Event Organisers": "முன்னெடுத்த நிகழ்வுகள்",
    "Field Operations": "களப்பணியாற்றிய நிகழ்வுகள்",
    "Election Contests": "தேர்தலில் போட்டியிட்டவைகள்",
    Pottiyittavaikal: "போட்டியிட்டவைகள்",
    "New Event": "புதிய நிகழ்வு",
    "Start date and End date": "தொடக்க தேதி மற்றும் இறுதி தேதி",
    Barracks: "பாசறைகள்",
    Barrack: "அமைப்பு",
    Event: "நிகழ்வு",
    Details: "விவரங்கள்",
    "Selected ones": "தேர்வு செய்யப்பட்டவைகள்",
    "Are you sure do you want to delete selected Event?":
      "உறுதியாக நீக்க விரும்புகிறீர்களா?",
    "Are you Sure do you want to deactivate this selected card?":
      "இந்த அட்டையை செயலிழக்கச் செய்ய  விரும்புகிறீர்களா?",
    "Are you Sure do you want to deactivate this selected section?":
      "இந்த பகுதியை செயலிழக்கச் செய்ய  விரும்புகிறீர்களா?",
    "Sync Remote Server": "உறுப்பினர்கள் பதிவிறக்கம் தரவு",
    "Party Positions": "பொறுப்புகள்",
    "Union Sub Sections": "உட்பிரிவுகள்",
    "Panchayat Sub Sections": "ஊராட்சி உட்பிரிவுகள்",
    "Ward Sub Sections": "சிறகம்(வார்டு)உட்பிரிவுகள்",
    "Ward Sections": "சிறகம்(வார்டு)",
    Sections: "பகுதிகள்",
    View: "பார்வையிடு",
    Receipt: "ரசீது எண்",
    "Receipt (Optional)": "ரசீது (கட்டாயமற்ற)",
    All: "அனைவரும்",
    "Invoice already included.": "பற்றுச்சீட்டு ஏற்கனவே சேர்க்கப்பட்டுள்ளது.",
    "role change": "பொறுப்பு மாற்றம்",
    "roles change reason": "காரணம்",
    "Party Roles": "பொறுப்புகள்",
    Information: "தகவல்",
    Chart: "வரைபடம்",
    "Items per page": "பக்கம் ஒன்றுக்கு விடயங்கள்",
    FAQ: "ஐயமும் தீர்வும்",
    "Search for a contribution": "பங்களிப்பைத் தேடுங்கள்",
    "Search for a expenses": "செலவுகளைத் தேடுங்கள்",
    "Search for a notes": "குறிப்புகளைத் தேடுங்கள்",
    "Votes History": "தேர்தல் வாக்குகள்",
    "Overview Party Positions": "பொறுப்பாளர்கள் நியமன விவரம்",
    "Overview Booth Agents": "வா.சாவடி நிர்வாகிகள் நியமன விவரம்",
    "Overview Barracks Positions": "பாசறை நிர்வாகிகள் நியமன விவரம்",
    Table: "அட்டவணை",
    Messages: "செய்திகள்",
    Help: "உதவி",
    Countries: "நாடுகள்",
    Statistics: "புள்ளிவிவரங்கள்",
    Districts: "மாவட்டங்கள்",
    Contacts: "தொடர்புகள்",
    Click: "கிளிக் செய்க",
    "Selected member is not eligible. For more details.":
      "தேர்ந்தெடுக்கப்பட்ட உறுப்பினர் தகுதி இல்லை. மேலும் விவரங்களுக்கு.",
    "இந்த பொறுப்பாளரை களப்பணியாளராக சேர்க்க இயலாது. மேலும் விவரம்...":
      "இந்த பொறுப்பாளரை களப்பணியாளராக சேர்க்க இயலாது. மேலும் விவரம்...",
    "இந்த பொறுப்பாளரை முன்னெடுத்தவராக சேர்க்க இயலாது. மேலும் விவரம்..":
      "இந்த பொறுப்பாளரை முன்னெடுத்தவராக சேர்க்க இயலாது. மேலும் விவரம்..",
    "Add responsible": "பொறுப்பாளரை சேர்க்கவும்",
    "Next Processing Date": "அடுத்த செயலாக்க தேதி",
    Next: "அடுத்து",
    Previous: "முந்தையது",
    "Recent Events": "அண்மை நிகழ்வுகள்",
    "Overview LokSabha Party Positions": "நாடாளுமன்ற பொறுப்பாளர் விவரம்",
    "Login History": "உள்நுழைவு வரலாறு",
    Remark: "குறிப்பு",
    Document: "ஆவணம்",
    Documents: "ஆவணங்கள்",
    "Add new document": "புதிய ஆவணத்தைச் சேர்க்கவும்",
    "Document title": "ஆவண தலைப்பு",
    "Document description": "ஆவண விளக்கம்",
    "Created By": "உருவாக்கியது",
    Creater: "உருவாக்கியவர்",
    Strength: "வலிமை",
    "Street Name": "தெரு பெயர்",
    pincode: "அஞ்சல் குறியீடு",
    "pincode error.": "அஞ்சல் குறியீடு தவறானது.",
    Error: "பிழை",
    "New Branch Added successfully.": "புதிய கிளை உருவாக்கப்பட்டது.",
    "Branch Added successfully.": "கிளை சேர்க்கப்பட்டது.",
    "Contests Added successfully.": "புதிய போட்டியாளர் சேர்க்கப்பட்டது.",
    "Contests Update successfully.":
      "போட்டியாளர் வெற்றிகரமாக புதுப்பிக்கப்பட்டது.",
    "Accepted file formats": "கோப்பு வகைகள்",
    "Copy Event": "நிகழ்வு நகல்",
    Overview: "மேலோட்டம்",
    "District Party Responsible": "மாவட்ட கட்சி பொறுப்பாளர்கள்",
    "District Barracks Responsible": "மாவட்ட பாசறை பொறுப்பாளர்கள்",
    "Cheif Roles": "தலைமை பொறுப்பாளர்கள்",
    "Member ID or Member Name": "உறுப்பினர் எண் அல்லது பெயர்",
    "Member Name": "உறுப்பினர் பெயர்",
    Note: "குறிப்பு",
    "Trainer Notes": "பயிற்றுநர் செய்தி",
    Title: "தலைப்பு",
    "Go Back": "பின்னே செல்க",
    "Sort by": "வரிசைப்படுத்துக",
    "Serial Number": "வரிசை எண்",
    Changelog: "பதிப்புகள்",
    Approved: "அங்கீகரிக்கப்பட்டது",
    "Not Approved": "அங்கீகரிக்கப்படாதவர்கள்",
    "Event Statistics": "நிகழ்வு புள்ளிவிவரம்",
    Email: "மின்னஞ்சல்",
    Designation: "பதவி",
    Status: "நிலைமை",
    "Assigned By": "பரிந்துரைத்தவர்",
    "Approved By": "அங்கீகரித்தவர்",
    "Rejected By": "நிராகரித்தவர்",
    "Assigned On": "பரிந்துரைக்கப்பட்ட தேதி",
    "Approved On": "அங்கீகரிக்கப்பட்ட தேதி",
    "Rejected On": "நிராகரிக்கப்பட்ட தேதி",
    "To Reject": "நிராகரிக்க",
    Rejected: "நிராகரிப்பு",
    Reason: "காரணம்",
    "Start Date": "தொடங்கிய நாள்",
    "End Date": "முடிவு நாள்",
    "Start Date and Time": "தொடங்கும் நாள் மற்றும் நேரம்",
    "Wating for Approve": "இன்னும் உறுதிபடுத்தப்படவில்லை",
    call: "அழைக்க",
    Delete: "நீக்குக",
    Branches: "கிளைகள்",
    Branch: "கிளை",
    "Post Status": "பொறுப்பு நிலவரம்",
    "Branch Post Status": "கிளை பொறுப்பு நிலவரம்",
    "Login Count": "உள்நுழை எண்ணிக்கை",
    "Attached Booths": "இணைக்கப்பட்ட வா.சாவடிகள்",
    "Non Attached Booths": "இணைக்கப்படாத வா.சாவடிகள்",
    "Total Booths": "மொத்த வா.சாவடிகள்",
    Recover: "திரும்பப்பெற",
    "Added Wards": "சேர்க்கப்பட்ட சிறகங்கள்(வார்டுகள்)",
    Voucher: "பற்றுச்சீட்டு",
    "Voucher No": "பற்றுச்சீட்டு எண்",
    "Internal Contribution": "மேம்பாட்டு நிதி",
    Collector: "பெறுபவர்",
    "Other Documents": "பிற ஆவணங்கள்",
    "Bank Accounts": "வங்கி கணக்குகள்",
    Administration: "நிர்வாகம்",
    "Account Name": "கணக்கு பெயர்",
    "Bank Name": "வங்கி பெயர்",
    "Account Number": "கணக்கு எண்",
    "IFSC Code": "IFSC குறியீடு",
    "Branch Address": "வங்கி கிளை முகவரி",
    "Date Opened On": "கணக்கு தொடங்கிய நாள்",
    "Attachment Files": "இணைப்பு கோப்புகள்",
    Yes: "ஆம்",
    "Attached Files": "இணைக்கப்பட்ட கோப்புகள்",
    Personal: "தனி நபர்",
    "Party Name": "கட்சி பெயரில்",
    Save: "சேமி",
    "Uploaded Files": "கோப்புகள்",
    "Inventory Details": "உபகரண விவரங்கள்",
    "Inventory type": "உபகரண வகை",
    "Move Panchayat": "ஊராட்சியை நகர்த்தவும்",
    "Select Union": "உட்பிரிவை தேர்ந்தெடுக்கவும்",
    "Reply to this topic": "இந்த தலைப்புக்கு பதில் அளி",
    "Submit reply": "பதிலைச் சமர்ப்பிக்க",
    Posted: "வெளியிடப்பட்டது",
    Reply: "பதிலளி",
    Notes: "குறிப்புகள்",
    "Vote count": "வாக்கு எண்ணிக்கை",
    "Post count": "பதவி எண்ணிக்கை",
    "Future events": "வரக்கூடிய நிகழ்வுகள்",
    "Public budget, subscription details": "பொது வரவு செலவு, சந்தா விவரம்",
    "Total Votes": "மொத்த வாக்குகள்",
    Voters: "வாக்காளர்கள்",
    votes: "வாக்குகள்",
    Timeline: "காலக்கோடு",
    Type: "பிரிவு",
    "General finances": "பொது வரவு-செலவு & சந்தா",
    Appointments: "முன்பதிவுகள்",
    "Appointment Details": "முன்பதிவு விவரம்",
    Time: "நேரம்",
    "Constituency Page": "தொகுதி பக்கம்",
    "Expense & Contributions": "வரவு-செலவு மேலோட்டம்",
    "Volume consultation and resolutions":
      "தொகுதி கலந்தாய்வு மற்றும் தீர்மானங்கள்",
    Resolutions: "தீர்மானங்கள்",
    Resolution: "தீர்மானம்",
    "Booth Statistics": "வா.சாவடிகள் விவரம்",
    "Report generation": "மாத அறிக்கைகள்",
    "Appointments List": "கலந்தாய்வுகள்",
    Home: "முகப்பு",
    "Inventory Lists": "அசையும் சொத்துக்கள்",
    "Stocks Management": "கொள்ளிருப்பு விவரங்கள்",
    Rentals: "வாடகை விவரம்",
    Letters: "கடிதத்தாள்கள்",
    "Letter Details": "கடிதத்தாள் விவரங்கள்",
    "Letter Lists": "கடிதப் பட்டியல்கள்",
    "Letter ID": "கடிதத்தாள் எண்",
    "Letter Date": "கடிதத்தாள் தேதி",
    "Approved Events Only": "ஒப்புதலானவைகள்",
    "Non Approved Events Only": "ஒப்புதலாகதவைகள்",
    Calander: "நாள்காட்டி",
    Submit: "சமர்ப்பி",
    "Finance Closure": "மாத கணக்கு அறிக்கைகள்",
    "Event ID": "நிகழ்வு எண்",
    Expense: "செலவீனம்",
    "Constituency Category": "தொகுதி வகை",
    "Post Name": "பதவி",
    LokSabha: "மக்களவை",
    Loksabha: "மக்களவை",
    loksabha_cons_name: "மக்களவை",
    loksabha_cons_id: "மக்களவை எண்",
    Place: "இடம்",
    Survey: "ஆய்வுகள்",
    Survey_ID: "ஆய்வு எண்",
    ID: "எண்",
    Others: "மற்றவை",
    Logout: "வெளியேறு ",
    Responsibility: "பொறுப்பாளர்",
    Spearheaded: "முன்னெடுத்தவர்",
    Kalappaniyalar: "களப்பணியாளர்",
    "All Wards": "அனைத்து வார்டுகளும்",
    "All Panchayats": "அனைத்து ஊராட்சிகளும்",
    "Primary Responsibilities": "முதல்நிலை பொறுப்புகள்",
    "Secondary Responsibilities": "இரண்டாம் நிலை பொறுப்புகள்",
    "Third Responsibilities": "மூன்றாம் நிலை பொறுப்புகள்",
    "Fourth Responsibilities": "நான்காம் நிலை பொறுப்புகள்",
    "Events Table": "நிகழ்வு அட்டவணை",
    "All Branches": "அனைத்து கிளைகள்",
    Calendar: "நாள்காட்டி",
    "Bug Fixes": "பிழை சரிசெய்தல்",
    New: "புதிய",
    MAKE: "உருவாக்க",
    Improvements: "மேம்பாடுகள்",
    "Constituency Posts": "தொகுதி பொறுப்புகள்",
    "Town Panchayat Posts": "பேரூராட்சி பொறுப்புகள்",
    "Panchayat Posts": "ஊராட்சி பொறுப்புகள்",
    "Union Posts": "ஒன்றிய பொறுப்புகள்",
    "Municipal Posts": "நகராட்சி பொறுப்புகள்",
    "Corporation Posts": "மாநகராட்சி பொறுப்புகள்",
    "Corporation Ward Posts": "மாநகராட்சி வார்டு பொறுப்புகள்",
    "Municipal Ward Posts": "நகராட்சி வார்டு பொறுப்புகள்",
    "Town Panchayat Ward Posts": "பேரூராட்சி வார்டு பொறுப்புகள்",
    "Member of the party?": "கட்சியின் உறுப்பினரா?",
    "Depending on your constituency?": "உங்கள் தொகுதியை சார்ந்தவரா?",
    "This person cannot be added as a promoter. For more details.":
      "இந்த பொறுப்பாளரை முன்னெடுத்தவராக சேர்க்க இயலாது. மேலும் விவரங்களுக்கு.",
    "Zone Districts": "கட்சி மாவட்டங்கள்",
    "Total Expense": "மொத்த வரவுகள்",
    Tamilnadu: "தமிழகம்",
    "No Booth added": "வா.சாவடி இணைக்கப்படவில்லை",
    "No members added": "உறுப்பினர்கள் இணைக்கப்படவில்லை",
    "Previous Month Balance": "முந்தைய மாத நிலுவை தொகை",
    "Assigned Party persons": "நியமிக்கப்பட்டவர்கள்",
    "Nominated party person": "பரிந்துரைக்கப்பட்டவர்கள்",
    "To Nominate": "பரிந்துரைக்க",
    "New Branch": "புதிய கிளை",
    "recently joined": "சமீபத்தில் சேர்ந்த",
    "Searched Member": "தேடப்பட்ட உறுப்பினர்",
    "Time Remain": "நேரம் மீதமுள்ளது",
    "Invalid member id.": "தவறான உறுப்பினர் எண்.",
    "Successfully removed.": "வெற்றிகரமாக அகற்றப்பட்டது.",
    Removed: "நீக்கம்",
    "There is no constituency available for your district.":
      "உங்கள் மாவட்டத்திற்கு எந்தத் தொகுதியும் கிடைக்கவில்லை.",
    "Unable to get data. Please try again.":
      "தரவைப் பெற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சி செய்க.",
    "District-Union list added successfully.":
      "மாவட்ட-யூனியன் பட்டியல் வெற்றிகரமாக சேர்க்கப்பட்டது.",
    "Panchayat added successfully.": "ஊராட்சி வெற்றிகரமாக சேர்க்கப்பட்டது.",
    "Unable to add panchayat. Please try again.":
      "ஊராட்சி சேர்க்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சி செய்க.",
    "Ward added successfully.": "சிறகம்(வார்டு)வெற்றிகரமாக சேர்க்கப்பட்டது.",
    "Unable to delete please try again.":
      "நீக்க முடியவில்லை மீண்டும் முயற்சிக்கவும்.",
    "Booth removed successfully.": "வா.சாவடி வெற்றிகரமாக அகற்றப்பட்டது.",
    "Unable to remove booth please try again.":
      "வா.சாவடியை அகற்ற முடியவில்லை மீண்டும் முயற்சிக்கவும்.",
    "Booth added successfully.": "வா.சாவடி வெற்றிகரமாக சேர்க்கப்பட்டது.",
    "Added successfully.": "வெற்றிகரமாக சேர்க்கப்பட்டது.",
    "Unable to add booth please try again.":
      "வா.சாவடி சேர்க்க முடியவில்லை, மீண்டும் முயற்சிக்கவும்.",
    "There is no data available. Please try again.":
      "தரவு எதுவும் கிடைக்கவில்லை. தயவுசெய்து மீண்டும் முயற்சி செய்க.",
    "Ward already added. (Duplicate Entry)":
      "சிறகம்(வார்டு)ஏற்கனவே சேர்க்கப்பட்டுள்ளது. (Duplicate Entry)",
    "Already added. (Duplicate Entry)":
      "ஏற்கனவே சேர்க்கப்பட்டுள்ளது. (Duplicate Entry)",
    "Unable to get posts. Please try again.":
      "பதிவுகள் பெற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சி செய்க.",
    "Please enter valid member id.": "சரியான உறுப்பினர் ஐடியை உள்ளிடவும்.",
    "Please select nomination status.": "பரிந்துரை நிலையைத் தேர்ந்தெடுக்கவும்.",
    "Please select election.": "தேர்தலைத் தேர்ந்தெடுக்கவும்.",
    "This person is already added for this election.":
      "இந்த நபர் இந்த தேர்தலுக்கு ஏற்கனவே சேர்க்கப்பட்டுள்ளார்.",
    "Another person has already been selected.":
      "மற்றொரு நபர் ஏற்கனவே தேர்ந்தெடுக்கப்பட்டுள்ளார்.",
    "Please upload valid application file.":
      "சரியான பயன்பாட்டுக் கோப்பைப் பதிவேற்றவும்.",
    "Is this panchayat shared with the other union council ward?":
      "இந்த ஊராட்சி மற்ற ஒன்றிய சபை சிறகங்களுடன்(வார்டுடன்) பகிரப்படுகிறதா?",
    "Your village union council has no other wards.":
      "உங்கள் கிராம ஒன்றிய  சபைக்கு வேறு எந்த சிறகங்களும்(வார்டுகளும்) இல்லை.",
    "There is no wards available for your district.":
      "உங்கள் மாவட்டத்திற்கு சிறகங்கள்(வார்டுகள்) இல்லை.",
    "Is this panchayat shared with the other district panchayat ward?":
      "இந்த ஊராட்சி மற்ற மாவட்ட ஊராட்சி சிறகங்களுடன்(வார்டுடன்) பகிரப்படுகிறதா?",
    "Ward to deleted successfully.": "சிறகம்(வார்டு)வெற்றிகரமாக நீக்கப்பட்டது.",
    "Deleted successfully.": "வெற்றிகரமாக நீக்கப்பட்டது.",
    "Unable to delete ward. Please try again.":
      "வார்டை நீக்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Ward category successfully updated.":
      "சிறகம்(வார்டு)வகை வெற்றிகரமாக புதுப்பிக்கப்பட்டது.",
    "Unable to update ward category. Please try again.":
      "சிறகம்(வார்டு)வகையை புதுப்பிக்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Choose panchayat name": "ஊராட்சி பெயரைத் தேர்வுசெய்க",
    "The panchayat is shared with the following district panchayat wards.":
      "இந்த ஊராட்சி பின்வரும் மாவட்ட ஊராட்சி சிறகங்களுடன்(வார்டுகளுடன்) பகிரப்படுகிறது.",
    "The panchayat is shared with the following union council wards.":
      "இந்த ஊராட்சி பின்வரும் ஒன்றிய சபை சிறகங்களுடன்(வார்டுகளுடன்) பகிரப்படுகிறது.",
    "The panchayat is not shared with any district panchayat wards.":
      "இந்த ஊராட்சி எந்த மாவட்ட ஊராட்சி சிறகங்களுடனும்(வார்டுகளுடனும்) பகிரப்படவில்லை.",
    "The panchayat is not shared with any union council wards.":
      "இந்த ஊராட்சி எந்த ஒன்றிய சபை சிறகங்களுடனும்(வார்டுகளுடனும்) பகிரப்படவில்லை.",
    "Select valid election category.":
      "சரியான தேர்தல் வகையைத் தேர்ந்தெடுக்கவும்.",
    "Select or Enter panchayat name.":
      "ஊராட்சி பெயரைத் தேர்ந்தெடுக்கவும் அல்லது உள்ளிடவும்.",
    "Panchayat updated successfully.":
      "ஊராட்சி வெற்றிகரமாக புதுப்பிக்கப்பட்டது.",
    "Updated successfully.": "வெற்றிகரமாக புதுப்பிக்கப்பட்டது.",
    "Unable to update panchayat. Please try again.":
      "பஞ்சாயத்தை புதுப்பிக்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "The panchayat is shared with other district panchayat wards.":
      "இந்த ஊராட்சி மற்ற மாவட்ட ஊராட்சி சிறகங்களுடன்(வார்டுகளுடன்)  பகிரப்படுகிறது.",
    "Unable to update contest. Please try again.":
      "போட்டியைப் புதுப்பிக்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "There is no constituency for this Lok Sabha constituency.":
      "இந்த லோக் சபா தொகுதிக்கு எந்த தொகுதியும் இல்லை.",
    "There is no lok sabha constituency for this country.":
      "இந்த நாட்டிற்கு லோக் சபா தொகுதி இல்லை.",
    "Unable to complete the process. Please try again.":
      "செயல்முறையை முடிக்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Please select valid panchayat name.":
      "சரியான ஊராட்சி பெயரைத் தேர்ந்தெடுக்கவும்.",
    "Unable to remove. Please try again.":
      "அகற்ற முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Maximum 6 files only.": "அதிகபட்சம் 6 கோப்புகள் மட்டுமே",
    "Already included.": "ஏற்கனவே சேர்க்கப்பட்டுள்ளது.",
    "Are you sure do you want to remove selected members.":
      "தேர்ந்தெடுக்கப்பட்ட உறுப்பினர்களை நீக்க விரும்புகிறீர்களா?",
    "Unable to add. Please try again.":
      "சேர்க்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Panchayat deleted successfully.": "ஊராட்சி வெற்றிகரமாக நீக்கப்பட்டது.",
    "Enter the correct section name.": "சரியான பிரிவு பெயரை உள்ளிடவும்.",
    "Role has not been approved.": "பொறுப்பு இன்னும் உறுதிப்படுத்தப்படவில்லை.",
    "Remove All wards in the panchayat":
      "இந்த ஊராட்சி மன்றத்தில் உள்ள அனைத்து சிறகங்களை(வார்டுகளை) நீக்கவும்.",
    "Remove all wards in this union.":
      "இதற்குள் உள்ளே உள்ள அனைத்து வார்டுகளயும் முதல்னிலில் நீக்கவும்.",
    "Remove all panchayats in this union.":
      "இந்த ஒன்றியத்தில் உள்ளே உள்ள அனைத்து ஊராட்சிகளையும்  முதலில் நீக்கவும்.",
    "Section contains wards.":
      "இந்த பகுதியில் உள்ளே உள்ள அனைத்து சிறகங்களை(வார்டுகளை)யும் முதலில் நீக்கவும்.",
    "Member has already been assigned a post. please check member's page.":
      "உறுப்பினர் ஏற்கனவே மற்றொரு பொறுப்பில் உள்ளார். உறுப்பினரின் பக்கத்தை பார்க்கவும்.",
    "Landing page access updated successfully.":
      "இறங்கும் பக்க அணுகல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது.",
    "Unable to update Landign page access. Please try again.":
      "லேண்டிங் பக்க அணுகலைப் புதுப்பிக்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "There are no events in the selected month.":
      "தேர்ந்தெடுக்கப்பட்ட மாதத்தில் நிகழ்வுகளும் எதுவும் நடைபெறவில்லை.",
    "Please enter valid contributor detail.":
      "சரியான பங்களிப்பாளரின் விவரத்தை உள்ளிடவும்.",
    "Please select valid date.": "சரியான தேதியைத் தேர்ந்தெடுக்கவும்.",
    "Please enter valid amount.": "சரியான தொகையை உள்ளிடவும்.",
    "Unable to update contribution. Please try again.":
      "பங்களிப்பைப் புதுப்பிக்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Unable to delete. Please try again.":
      "நீக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சி செய்க.",
    "Unable to update. Please try again.":
      "புதுப்பிக்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Please check your internet connection.":
      "உங்கள் இணைய இணைப்பை சரிபார்க்கவும்.",
    "There is no contribution available for selected data. Please try again.":
      "தேர்ந்தெடுக்கப்பட்ட தரவுகளுக்கு எந்த பங்களிப்பும் கிடைக்கவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Expense updated successfully.": "செலவு வெற்றிகரமாக புதுப்பிக்கப்பட்டது.",
    "Unable to add expense. Please try again.":
      "செலவைச் சேர்க்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சி செய்க.",
    "Expense added successfully.": "செலவு வெற்றிகரமாக சேர்க்கப்பட்டது.",
    "Moved Successfully.": "வெற்றிகரமாக நகர்த்தப்பட்டது.",
    "Successfully Changed Pin.":
      "இரகசிய குறியீட்டு எண் வெற்றிகரமாக அகற்றப்பட்டது.",
    "Doesn't change pin": "ரகசிய குறியீடு எண் அகற்றமுடியவில்லை",
    "restrictions changed.": "கட்டுப்பாடுகள் மாற்றப்பட்டன.",
    "Unable to update expense. Please try again.":
      "செலவைப் புதுப்பிக்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "You can only upload maximum 6 files.":
      "நீங்கள் அதிகபட்சம் 6 கோப்புகளை மட்டுமே பதிவேற்ற முடியும்.",
    "Maximum upload size per file is 25mb. Some of your file will be ignored.":
      "ஒரு கோப்பிற்கு அதிகபட்ச பதிவேற்ற அளவு 25mb ஆகும். உங்கள் கோப்பில் சில புறக்கணிக்கப்படும்.",
    "Maximum upload size per file is 25mb. Your selected file will be ignored.":
      "ஒரு கோப்பிற்கு அதிகபட்ச பதிவேற்ற அளவு 25mb ஆகும். நீங்கள் தேர்ந்தெடுத்த கோப்பு புறக்கணிக்கப்படும்.",
    "Unable to get data please try again.":
      "தரவைப் பெற முடியவில்லை, மீண்டும் முயற்சிக்கவும்.",
    "Are you sure do you want to post without files?":
      "கோப்புகள் இல்லாமல் இடுகையிட விரும்புகிறீர்களா?",
    "Upload failed. Please try again.": "Upload failed. Please try again.",
    "Already approved.": "ஏற்கனவே ஒப்புதல் அளிக்கப்பட்டுள்ளது.",
    "Party post already deleted.": "கட்சி இடுகை ஏற்கனவே நீக்கப்பட்டுவிட்டது.",
    "Approved successfully.": "வெற்றிகரமாக அங்கீகரிக்கப்பட்டது.",
    "Unable to approve please try again.":
      "அங்கீகரிக்க முடியவில்லை மீண்டும் முயற்சிக்கவும்.",
    "Please enter valid reason.": "சரியான காரணத்தை உள்ளிடவும்.",
    "Rejected successfully.": "வெற்றிகரமாக நிராகரிக்கப்பட்டது.",
    "Unable to reject please try again.":
      "நிராகரிக்க முடியவில்லை மீண்டும் முயற்சிக்கவும்.",
    "Member does not belong to this constituency!":
      "உறுப்பினர் இந்த தொகுதி சார்ந்தவர் இல்லை!",
    "Remove all events in this union.":
      "இதில் உள்ள அனைத்து நிகழ்வுகளையும் நீக்கவும்.",
    "Section removed successfully.": "பகுதி வெற்றிகரமாக அகற்றப்பட்டது.",
    "Unable to remove section. Please try again.":
      "பகுதியை அகற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சி செய்க.",
    "Contribution deleted successfully.":
      "பங்களிப்பு வெற்றிக்கரமாக நீக்கப்பட்டது.",
    "Deleted successfully!": "வெற்றிக்கரமாக நீக்கப்பட்டது.",
    "Approval can only be made while the appointment is ongoing.":
      "நியமனம் நடந்து கொண்டிருக்கும் போது மட்டுமே ஒப்புதல் அளிக்க முடியும்.",
    "Can't update, appointment already closed.":
      "புதுப்பிக்க முடியாது, கலந்தாய்வு ஏற்கனவே முடிந்தது.",
    "Reject can only be made while the appointment is ongoing.":
      "நியமனம் நடந்து கொண்டிருக்கும் போது மட்டுமே நிராகரிக்க முடியும்.",
    "The appointment can only be taken up for discussion while it is ongoing.":
      "நியமனம் நடந்து கொண்டிருக்கும் போது மட்டுமே விவாதத்திற்கு எடுத்துக்கொள்ள முடியும்.",
    "Contribution updated successfully.":
      "பங்களிப்பு வெற்றிக்கரமாக மேம்படுத்தப்பட்டது.",
    "Contribution added successfully.":
      "பங்களிப்பு வெற்றிக்கரமாக சேர்க்கப்பட்டது.",
    "You can't add kalapaniyalar without munneduthavar.":
      "முன்னெடுத்தவர்கள் இல்லாமல் களப்பணியாளர்கள் சேர்க்க முடியாது.",
    "You can't remove munneduthavar with kalapaniyalar.":
      "களப்பணியாளர்கள் இருக்கும் போது முன்னெடுத்தவர்களை நீக்க முடியாது.",
    "Unable to add ward note.": "சிறகம்(வார்டு)குறிப்பைச் சேர்க்க முடியவில்லை.",
    "Ward note added successfully.":
      "சிறகம்(வார்டு)குறிப்பு வெற்றிகரமாக சேர்க்கப்பட்டது.",
    "You can't add more than 20,000.":
      "நீங்கள் 20,000 க்கு மேல் சேர்க்க முடியாது.",
    "Remove booths from branches.":
      "இந்த வா.சாவடியை கிளையில் இருந்து முதலில் அகற்றவும்.",
    "Branch added successfully.": "கிளை வெற்றிகரமாக சேர்க்கப்பட்டது.",
    "Branch note added successfully.":
      "கிளை குறிப்பு வெற்றிகரமாக சேர்க்கப்பட்டது.",
    "Unable to add branch note.": "கிளை குறிப்பைச் சேர்க்க முடியவில்லை.",
    "Branch deleted successfully.": "கிளை வெற்றிகரமாக நீக்கப்பட்டது.",
    "Unable to add branch. Please try again.":
      "கிளையை சேர்க்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "Unable to delete branch. Please try again.":
      "கிளையை நீக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "Branch already added. (Duplicate Entry)":
      "கிளை ஏற்கனவே சேர்க்கப்பட்டுள்ளது. (Duplicate Entry)",
    "Corporations daily wise": "மாநகராட்சிகள் தினசரி வாரியாக",
    "Corporations monthly wise": "மாநகராட்சிகள் மாத வாரியாக",
    "Municipalities monthly wise": "நகராட்சிகள் மாத வாரியாக",
    "Municipalities daily wise": "நகராட்சிகள் தினசரி வாரியாக",
    "Town panchayats monthly wise": "பேரூராட்சிகள் மாத வாரியாக",
    "Town panchayats daily wise": "பேரூராட்சிகள் தினசரி வாரியாக",
    "Unions monthly wise": "ஒன்றியங்கள் மாத வாரியாக",
    "Unions daily wise": "ஒன்றியங்கள் தினசரி வாரியாக",
    "Login monthly wise": "உள்நுழை மாத வாரியாக",
    "Login daily wise": "உள்நுழை தினசரி வாரியாக",
    "Event recovered successfully.": "நிகழ்வு வெற்றிகரமாக மீட்கப்பட்டது.",
    "Unable to recover event. Please try again.":
      "நிகழ்வை மீட்டெடுக்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Party post Not approved yet.": "இன்னும் பொறுப்பு ஒப்புதல் பெறவில்லை.",
    "Remove kalapaniyalargal.": "களப்பணியாளர்களை நீக்கவும்.",
    "Remove munneduthavargal.": "முன்னெடுத்தவர்களை நீக்கவும்.",
    "Remove porupalargal.": "பொறுப்பாளர்களை நீக்கவும்.",
    "Remove uploaded files.": "கோப்புகளை நீக்கவும்.",
    "Remove booths.": "வா.சாவடிகளை நீக்கவும்.",
    "Is the Joint Account?": "இணைப்பு கணக்கா?",
    "Did you get letter from company?":
      "கட்சியிடம் இருந்து கடிதம் வாங்குனீர்களா?",
    "The bank account is in your name or company name?":
      "வங்கி கணக்கு தனி நபர் பெயரில் உள்ளதா அல்லது கட்சியின் பெயரில் உள்ளதா?",
    "Bank account details added successfully.":
      "வங்கி கணக்கு விவரங்கள் வெற்றிகரமாக சேர்க்கப்பட்டன.",
    "Bank account details updated successfully.":
      "வங்கி கணக்கு விவரங்கள் வெற்றிகரமாக புதுப்பிக்கப்பட்டன.",
    "Unable to add bank details. Please try again.":
      "வங்கி விவரங்களைச் சேர்க்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Unable to update bank details. Please try again.":
      "வங்கி விவரங்களைச் புதுப்பிக்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Please fill all details.": "அனைத்து விவரங்களையும் நிரப்பவும்.",
    "Booth already added.": "வா.சாவடி ஏற்கனவே சேர்க்கப்பட்டுள்ளது.",
    "Unable to add booth number. Please try again.":
      "வா.சாவடி எண்ணைச் சேர்க்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Unable to remove old booth number. Please try again.":
      "பழைய வா.சாவடி எண்ணை அகற்ற முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Booth number added successfully.":
      "வா.சாவடி எண் வெற்றிகரமாக சேர்க்கப்பட்டது.",
    "Reply posted successfully.": "பதில் வெற்றிகரமாக இடுகையிடப்பட்டது.",
    "Unable to post. Please try again.":
      "இடுகையிட முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Can't post empty message.": "வெற்று செய்தியை இடுகையிட முடியாது.",
    "Posted successfully.": "வெற்றிகரமாக இடுகையிடப்பட்டது.",
    "Ward moved successfully.": "சிறகம் (வார்டு) வெற்றிகரமாக நகர்த்தப்பட்டது.",
    "Unable to move ward. Please try again.":
      "சிறகத்தை (வார்டை) நகர்த்த முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Removed successfully.": "வெற்றிகரமாக அகற்றப்பட்டது.",
    "There is no notes available.": "குறிப்புகள் எதுவும் இல்லை.",
    "Total voters updated successfully.":
      "மொத்த வாக்காளர்கள் எண்ணிக்கை சேர்க்கப்பட்டது.",
    "Unable to update voters. Please try again.": "சேர்க்க முடியவில்லை.",
    "Duplicate finance details exists.":
      "ஏற்கனவே இதே பிரிவு சேர்க்கப்பட்டுள்ளது.",
    "Invalid pincode.": "தவறான அஞ்சல் குறியீடு.",
    "No appointments booked.": "நியமனங்கள் எதுவும் பதிவு செய்யப்படவில்லை.",
    "Already you have booked an appointment.":
      "ஏற்கனவே ஒரு கலந்தாய்வு திட்டமிடப்பட்டுள்ளது.",
    "Event Not approved yet.": "நிகழ்வு இன்னும் ஒப்புதல் பெறவில்லை.",
    "Please fill all fields.": "விவரங்களை நிரப்பவும்.",
    "Post successfully assigned": "பொறுப்பு வெற்றிகரமாக ஒதுக்கப்பட்டுள்ளது",
    "Unable to continue. Please try again.":
      "தொடர முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சி செய்க.",
    "Resolution assigned successfully.":
      "தீர்மானம் வெற்றிகரமாக ஒதுக்கப்பட்டுள்ளது.",
    "Secondary reference": "இரண்டாம் நிலை குறிப்பு.",
    "Third reference": "மூன்றாவது குறிப்பு.",
    "First reference": "முதல் நிலை குறிப்பு.",
    "Reference Id": "குறிப்பு எண்",
    "Sub Reference Id": "துணை குறிப்பு எண்",
    Modified: "மாற்றியமைக்கப்பட்டது",
    Continue: "தொடரவும்",
    Created: "உருவாக்கப்பட்டது",
    "Wards in Town Panchayat": "பேரூராட்சி வார்டுகள்",
    "Wards in Municipal": "நகராட்சி வார்டுகள்",
    "Wards in Corporation": "மாநகராட்சி வார்டுகள்",
    "Event description must be filled in at least 50 words.":
      "நிகழ்வு விவரம் குறைந்தது 50 சொற்கள் நிரப்ப்பட்டு இருக்க வேண்டும்.",
    "If there are any objections post the reason for it.":
      "எதிர்ப்புகள் ஏதும் இருந்தால் அதற்கான காரணத்தை பதிவிடவும்.",
    "Reason for rejection. (Upload a letter of complaint).":
      "நிராகரிக்கப்படுவதற்கான காரணம். (புகார் கடிதம் இருந்தால் பதிவேற்றவும்)",
    "Reason for suspension.": "நிறுத்தி வைக்கப்படுவதற்கான காரணம்.",
    "Post / Assigned": "பொறுப்பு / நியமித்தது",
    "Update document": "ஆவணத்தைப் புதுப்பிக்கவும்",
    "Document added successfully.": "ஆவணம் வெற்றிகரமாக சேர்க்கப்பட்டது.",
    "Unable to add document. Please try again.":
      "ஆவணத்தைச் சேர்க்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சி செய்க.",
    "Document updated successfully.": "ஆவணம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது.",
    "Unable to update document. Please try again.":
      "ஆவணத்தைப் புதுப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சி செய்க.",
    "Field Workers": "களப்பணியாளர்கள்",
    EVENT_STATUS: {
      Approved: "ஒப்புதல் அளிக்கப்பட்டது",
      Rejected: "நிராகரிக்கப்பட்டது",
      Pending: "பரிசோதனைக்குட்பட்டது",
    },
    MEMBER_VIEW: {
      Advances: "முன்னெடுத்தவைகள்",
      Fieldwork: "களப்பணிகள்",
      "Economic contributions": "பொருளாதர பங்களிப்புகள்",
      "Login history": "உள்நுழைவு வரலாறு",
      "Local Election": "உள்ளாட்சி தேர்தல்",
      Survey: "ஆய்வுகள்",
    },
    SURVEY: {
      "Movable property value": "அசையும் சொத்து மதிப்பு",
      "Immovable property value": "அசையா சொத்து மதிப்பு",
      Profile: "சுயவிவரம்",
      "Study Work": "படிப்பு வேலை",
      Income: "வருமானம்",
      Cases: "வழக்குகள்",
      "Previous Matches": "முந்தைய போட்டிகள் (நாடாளுமன்றம், உள்ளாட்சி உட்பட)",
      "Interested constituencies": "விருப்பத் தொகுதிகள்",
      "Social struggles": "சமூக போராட்டங்கள்",
      Compliments: "பாராட்டுகள்",
      Problems: "தொகுதி பிரச்சனைகள் (குறைந்தது 10)",
      "Social Welfare Scheme": "சமூக நலத்திட்டம்",
      "Added Successfully.": "வெற்றிகரமாக சேர்க்கப்பட்டது.",
      "Already added!": "ஏற்கனவே சேர்க்கப்பட்டுள்ளது!",
      "Unable to add. Please try again.":
        "சேர்க்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
      "Your family members are having any party positions?":
        "உங்கள் குடும்ப உறுப்பினர்கள் நாம் தமிழர் கட்சி பொறுப்பில் உள்ளார்களா?",
      "Will you attend the training?":
        "நீங்கள் பயிற்சியில் கலந்து கொள்வீர்களா?",
      "Physically challenged?": "மாற்று திறனாளியா?",
      "Who has the opportunity to compete in a separate constituency?":
        "தனி தொகுதியில் போட்டியிடும் வாய்ப்புள்ளவரா?",
      Qualification: "படிப்பு தகுதி",
      Profession: "தொழில்",
      "Family Assets": "குடும்ப சொத்துக்கள் மதிப்பு விவரம்",
      "Annual Income": "ஆண்டு வருமானம்",
      "Have you ever arrested for protesting?":
        "போராடியததற்காக நீங்கள் எப்போதாவது கைது செய்யப்பட்டுள்ளீர்களா?",
      "Spent in Jail in more than 1 day?":
        "1 நாளுக்கு மேல் சிறையில் இருந்துள்ளீர்களா?",
      "Cases from party protests?":
        "கட்சி ஆர்ப்பாட்டங்களிலிருந்து கைது செய்ய பட்டுள்ளீர்களா?",
      "Own cases?":
        "கட்சி சார்பு அல்லாத தனி நபர் குற்ற வழக்குகள் உங்கள் மீது உள்ளதா?",
      "Previous Contested?": "தேர்தலில் இதற்கு முன் போட்டியிட்டுள்ளீர்களா?",
      "Will you agree for second choice?":
        "இரண்டாவது தேர்வுக்கு ஒப்புக்கொள்வீர்களா?",
      "Have you registered any complaints and case for people and society cause?":
        "மக்கள் மற்றும் சமூக பிரச்சனைகளுக்காக ஏதேனும் புகார்கள் மற்றும் வழக்கை பதிவு செய்துள்ளீர்களா?",
      "Have you won?": "வழக்கில் வென்று இருக்கிறீர்களா?",
      "Have you ever filed any RTI for causes?":
        "தகவல் அறியும் உரிமை சட்டத்தின் கீழ் தகவல் பெற்று சமூக பிரச்சனைக்கு தீர்வு காண முற்பட்டுள்ளீர்களா?",
      "Have you got any recognisition from society?":
        "உங்களின் சமூகப்பணிக்கான அங்கீகாரம் (விருதுகள், சான்றிதல், பாராட்டுப்பத்திரம்) எதுவும் பெற்றுள்ளீர்களா?",
      "Have you got any recognisition from your work organisation?":
        "நீங்கள் வேலைப்பார்க்கும் நிறுவனத்திடமிருந்து உங்களுக்கு ஏதேனும் அங்கீகாரம் கிடைத்ததா?",
      Details: "விவரங்கள்",
      "Already submitted! Can't modify anything.":
        "ஏற்கனவே சமர்ப்பிக்கப்பட்டது! எதையும் மாற்ற முடியாது.",
      "Submitted Successfully.": "வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது.",
      "Mother Tongue": "தாய் மொழி",
      "Are you married?": "திருமணம் ஆனவரா?",
      Community: "சமூகம்?",
    },
    "Created On": "உருவாக்கப்பட்ட தேதி",
    "Optional petition": "விருப்ப மனு",
    "Login history": "உள்நுழைவு வரலாறு",
    "Naam Tamiler Katchi": "நாம் தமிழர் கட்சி",
    "Copy File": "நகலெடுக்க",
    "Nothing can be changed after submission.":
      "சமர்ப்பித்த பிறகு எதையும் மாற்ற செய்ய முடியாது.",
    "Are you sure you want to delete?":
      "இதை நீக்க வேண்டும் என்பதில் உறுதியாக இருக்கிறீர்களா?",
    "Are you sure you want to stop?":
      "இதை நிறுத்த வேண்டும் என்பதில் உறுதியாக இருக்கிறீர்களா?",
    "Approval can be given only during the monthly account closing consultation.":
      "மாத கணக்கு முடிப்பு கலந்தாய்வின் போது மட்டும்தான் ஒப்புதல் அளிக்க முடியும்.",
    "You cannot change anything after downloading the receipt. Continue?":
      "ரசீதைப் பதிவிறக்கிய பிறகு நீங்கள் எதையும் மாற்ற முடியாது. தொடரவா?",
    "You can not change anything after selecting and submitting that the money has been paid. Continue?":
      "பணத்தை செலுத்தி விட்டார் என்று தேர்ந்தெடுத்து சமர்ப்பித்த பிறகு நீங்கள் எதையும் மாற்ற முடியாது. தொடரவா?",
    Confirm: "உறுதி செய்க",
    "Full Details": "முழு விவரம்",
    "Enter Vots": "வாக்கு எண்ணிக்கையை பதிவிடுக...",
    DOB: "பிறந்த தேதி",
    "With Branch": "கிளை உள்ளவர்கள்",
    "Without Branch": "கிளை இல்லாதவர்கள்",
    "For More": "மேலும் விவரம்",
    "Only one booth can be selected.":
      "ஒரு வா.சாவடிக்கு மேல் தேர்வு செய்ய முடியாது.",
    "Unable to add booth. Please try again.":
      "வா.சாவடி சேர்க்க முடியவில்லை. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    "Please remove all the posts assigned to this booth.":
      "இந்த சாவடிக்கு ஒதுக்கப்பட்ட அனைத்து பொறுப்புகளையும் அகற்றவும்.",
    "The polling station administrator must be responsible for the party union / city / municipality / corporation area / wing.":
      "வாக்குச்சாவடி நிர்வாகி கட்டாயமாக கட்சியில ஒன்றிய/நகர/பேரூராட்சி/மாநகராட்சி பகுதி/சிறகம் இதில் ஒரு பொறுப்பை வகிக்க வேண்டும்.",
    "Polling Manager No more than 5 polling stations.":
      "வாக்குச்சாவடி நிர்வாகி 5 வாக்குச்சாவடிக்கும் மேல் நிர்வாகிக்க முடியாது.",
    "The sole member shall not be responsible for the polling administrator and the agent.":
      "ஒரே உறுப்பினர் வாக்குச்சாவடி நிர்வாகி மற்றும் முகவர் பொறுப்பை கொண்டிருக்கக்கூடாது.",
    "Create at least one branch for the polling station.":
      "ஒரு வாக்குச்சாவடிக்கு குறைந்தது ஒரு கிளையை உருவாக்க வேண்டும்.",
    "I have checked the liability information. I understand that once the letter has been approved, it cannot be amended.":
      "பொறுப்பு தகவல்களை சரிபார்த்து விட்டேன். ஒப்புதலாகி கடிதத்தாள் உருவாகி விட்டால் திருத்த முடியாது என்பதை விளங்கி கொள்கிறேன்.",
    "Are you agree save branch details.":
      "கிளை விவரங்களைச் சேமிக்க ஒப்புக்கொள்கிறீர்களா?",
    "Series no": "தொடர் இல",
    "Indian Amount": "இந்திய தொகை",
    "Foreign Amount": "வெளிநாட்டு தொகை",
    "Updated On": "புதுப்பிக்கப்பட்டது",
    "Updated By": "புதுப்பித்தார்",
    "Invalid receipt no.": "தவறான ரசீது எண்.",
    "Receipt already used.": "ரசீது ஏற்கனவே பயன்படுத்தப்பட்டுள்ளது.",
    Success: "வெற்றி",
    Failed: "தோல்வி",
    "Domestic amount": "உள்நாட்டுத் தொகை",
    Post: "பொறுப்பு",
    Section: "பகுதி",
    "Post Start Date": "ஆரம்ப நாள்",
    "Post End Date": "முடிவு நாள்",
    Desings: "வடிவங்கள்",
    Forms: "படிவங்கள்",
    Logos: "இலச்சினைகள்",
    "Case Studies": "வழக்கு ஆய்வுகள்",
    "more details": "மேலும் விவரம்",
    "Amount Paid": "பணத்தை செலுத்தி விட்டார்",
    "The same section is already included.":
      "ஏற்கனவே இதே பிரிவு சேர்க்கப்பட்டுள்ளது.",
    "Election campaign": "தேர்தல் பரப்புரை",
    Phone: "தொலைபேசி",
    "Election Working Group": "தேர்தல் பணிக்குழு",
    Confirmation: "உறுதிப்படுத்தல்",
    "Member Address": "உறுப்பினர் முகவரி",
    num_vehicles: "மொத்தம் எத்தனை வாகனங்கள்",
    num_signs: "மொத்தம் எத்தனை கையெழுத்துகள்",
    num_notices: "கொடுக்கப்பட்ட துண்டறிக்கைகள் எண்ணிக்கை",
    num_members_added: "சேர்க்கப்பட்ட உறுப்பினர் எண்ணிக்கை",
    num_houses: "மொத்தம் எத்தனை வீடுகள்",
    num_boards: "மொத்தம் எத்தனை வணிக பலகைகள்",
    num_beneficiers: "பயனடைந்தவர்கள் எண்ணிக்கை",
    num_attenders: "கலந்து கொண்டவர்கள் எண்ணிக்கை",
    num_kilometers_travelled: "பயணம் செய்த தூரம் (கி.மீ)",
    num_people_added: "மொத்தம் சேர்க்கப்பட்டவர்கள் எண்ணிக்கை",
    num_flags: "நடப்பட்ட (அ) கொடுக்கப்பட்ட கொடிகள் எண்ணிக்கை",
    num_posters: "ஒட்டப்பட்ட சுவரொட்டி எண்ணிக்கை",
    spear_head: "முன்னெடுத்தவர்கள்",
    field_work: "களப்பணியாளர்கள்",
    responsibler: "நிகழ்வு பொறுப்பாளர்கள்",
    attenders: "கலந்து கொண்டவர்கள்",
    res_supporters: "தீர்மானத்தை ஆதரிப்போர்கள்",
    res_oppositer: "தீர்மானத்தை எதிர்ப்போர்கள்",
    "blood-donars": "குருதி கொடுத்தவர்கள்",
    num_donars: "குருதி கொடுத்தவர்கள் எண்ணிக்கை",
    num_trees_planted: "நடப்பட்ட மரங்களின் எண்ணிக்கை",
    num_trees_donated: "கொடுக்கப்பட்ட மரங்கன்று எண்ணிக்கை",
    campainers: "பரப்புரை செய்தவர்கள்",
    Responsibilities: "பொறுப்புகள்",
    AppVersion: "செயலியின் பதிப்பு",
    Donation: "நன்கொடை",
    "Donation Member Details": "நன்கொடை உறுப்பினர் விவரங்கள்",
    "Donation Plan Details": "நன்கொடை திட்ட விவரங்கள்",
    "Payment Id": "கட்டண எண்",
    "Order Id": "ஆர்டர் எண்",
    "Donation Table": "  நன்கொடை அட்டவணை",
    "Donation Plan Cancel": "நன்கொடை திட்டம் ரத்து",
    Donation_Plan: "  நன்கொடை திட்டம்",
    Subscription: "சந்தா",
    Tenure: "காலம்",
    "Subscription Id": "சந்தா எண்",
    "Subscription Note": "சந்தா குறிப்பு",
    "Subscription Table": "சந்தா அட்டவணை",
    "Subscription Data": "சந்தா தகவல்கள்",
    "Subscription Plan Cancel": "சந்தா திட்டம் ரத்து",
    "Processing Day": "செயலாக்க நாள்",
    Member_Survey_List: "உறுப்பினர் கணக்கெடுப்பு பட்டியல்",
    Recent_Party_Posts: "சமீபத்திய கட்சி பதிவுகள்",

    file_upload: "கோப்புகள்",
    "Booth Number": "வா.சா.எண்",
    "Sorry, only Indian citizens can donate under the Election Commission of India Act. Thank you for your support.":
      "மன்னிக்கவும், இந்திய தேர்தல் ஆணைய சட்டத்தின் கீழ் இந்திய குடிமக்கள் மட்டுமே நன்கொடை வழங்க முடியும். உங்கள் ஆதரவுக்கு நன்றி.",
    "Amount can't be more than Rs.19,500.":
      "தொகை ரூ .19,500 க்கு மேல் இருக்கக்கூடாது.",
    "Complete the previous month's account.": "முந்தைய மாத கணக்கை முடிக்கவும்.",
    "Union / Municipal Sections": "ஒன்றியம் / நகராட்சி பகுதி",
    "Panchayats / Wards": "ஊராட்சிகள் / சிறகங்கள்",
    "Home Banners": "வீட்டு பதாகைகள்",
    "Name of the builder": "கட்டியவர் பெயர்",
    homeowner: "வீட்டு உரிமையாளர்",
    "Event Date": "நிகழ்வு நாள்",
    "Move member to branch": "உறுப்பினரை கிளைக்கு நகர்த்தவும்",
    "Create an event called Home Banners in the event areas will be displayed here.":
      "நிகழ்வு பகுதிகளில் வீட்டு பதாகைகள் என்ற நிகழ்வை உருவாக்கினால் இங்கு காட்டப்படும்.",
    "This member already have branch.":
      "இந்த உறுப்பினருக்கு ஏற்கனவே கிளை உள்ளது.",
    Done: "முடிந்தது",
    "S.No": "வா.எண்",
    "SubGroup Name": "துணைக்குழு பெயர்",
    "SubGroup Id": "துணைக்குழு எண்",
    "To_SubGroup Id": "துணைக்குழு எண்க்கு",
    "Group Index": "குழு அட்டவணை",
    "Group Id": "குழு எண்",
    "To_Group Id": "குழு எண்க்கு",
    "Group Name": "குழுவின் பெயர்",
    "To_Place Id": "இடத்தின் எண்க்கு",
    "Place Id": "இடத்தின் எண்",
    "Place Name": "இடத்தின் பெயர்",
    "Question Index": "கேள்வி அட்டவணை",
    "Option Index": "விருப்பத்தேர்வு அட்டவணை",
    "Option Title": "விருப்பத்தேர்வு பெயர்",
    "Default value": "இயல்புநிலை மதிப்பு",
    "Default option": "இயல்புநிலை விருப்பம்",
    "Minimum Value": "குறைந்தபட்ச மதிப்பு",
    "Maximum Value": "அதிகபட்ச மதிப்பு",
    "Parent Question Id": "மூல கேள்வி எண்",
    "Parent Answer If": "மூல பதில்",
    "Conditional Operator": "நிபந்தனை இயக்குபவர்",
    "Number of Months": "மாதங்களின் எண்ணிக்கை",
    Mandatory: "கட்டாயமாகும்",
    lp: "எல்பி",
    "Post Key": "முக்கிய பதவி",
    "Primary Role": "முதன்மை பங்கு",
    Visible: "புலப்படும்",
    Invisible: "புலப்படாது",
    Requests: "கோரிக்கைகள்",
    "New request": "புதிய கோரிக்கை",
    "Request Number": "கோரிக்கை எண்",
    "object name": "பொருள் பெயர்",
    "Date required": "தேவைப்படும் தேதி",
    Counts: "எண்ணிக்கை",
    "Name of the applicant": "கோரிக்கையாளர் பெயர்",
    "Requester number": "கோரிக்கையாளர் எண்",
    AddSubgroup: "துணைக்குழுவைச் சேர்க்க",
    "Add New Section": "புதிய பகுதியைச் சேர்க்க",
    "Add Application Questions": "விண்ணப்பக் கேள்விகளைச் சேர்க்க",
    "Add Application Answers": "விண்ணப்பக் விடைகளைச் சேர்க்க",
    "To Change Union": "ஒன்றியத்தை மாற்ற",
    "Sent on demand": "தேவை அனுப்பப்பட்டது",
    "Request received": "கோரிக்கை பெறப்பட்டது",
    "Request details": "கோரிக்கை விவரங்கள்",
    Requester: "கோரிக்கையாளர்",
    "shipping address": "சேரும் முகவரி",
    "Add Application": "விண்ணப்பத்தை சேர்க்க",
    "Edit Application": "விண்ணப்பத்தை திருத்த",
    "Add Question Group": "கேள்விக் குழுவைச் சேர்க்க",
    "Question Group Id": "கேள்விக் குழு எண்",
    "Question Group Title": "கேள்விக் குழு தலைப்பு",
    "Request status": "கோரிக்கை நிலை",
    "To select the request position": "கோரிக்கை நிலையை தேர்வு செய்ய",
    Renewal: "புதுப்பித்தல்",
    "Your request level has not yet been selected":
      "உங்களது கோரிக்கை நிலை இன்னும் தேர்வு செய்யப்படவில்லை",
    "Is pending": "நிலுவையில் உள்ளது",
    "Supplier details": "சப்ளையர் விவரங்கள்",
    Files: "கோப்புகள்",
    "Candidate Image": "வேட்பாளர் புகைப்படம்",
    "Member Image": "உறுப்பினர் புகைப்படம்",
    Image: "புகைப்படம்",
    "Recommender Image": "பரிந்துரைத்தவர் புகைப்படம்",
    "Recommender Name": "பரிந்துரைத்தவர் பெயர்",
    "Recommender Id": "பரிந்துரைத்தவர் எண்",
    Recommend: "பரிந்துரை",
    confirm: "உறுதி",
    recognition: "அங்கீகாரம்",
    "Member Place": "உறுப்பினர் இடம்",
    "Candidate Account or Not?": "வேட்பாளர் கணக்கா?",
    "Nomination Date": "வேட்புமனு தேதி",
    "Nomination Details": "வேட்புமனு விவரம்",
    "Candidate account": "வேட்பாளர் கணக்கு",
    "Deposit Paid": "வைப்புத்தொகை செலுத்தப்பட்டது",
    "Candidate Name": "வேட்பாளர் பெயர்",
    "Booth Name": "வா.சாவடி பெயர்",
    "Booth Area": "வா.சாவடி பகுதி",
    "Your Request Success": "கோரிக்கை நிறைவேற்றப்பட்டது",
    Start: "தொடங்கு",
    "Completed Successfully": "வெற்றிகரமாக முடிந்தது",
    "Annual Report Opportunity": "ஆண்டு அறிக்கை வாய்ப்பு",
    "Blood donation": "குருதி கொடை",
    "Donor Name": "நன்கொடையாளர் பெயர்",
    "Donor Member Id": "நன்கொடையாளர் உறுப்பினர் எண்",
    "Donor Phone Number": "நன்கொடையாளர் தொலைபேசி எண்",
    "Donor Address": "நன்கொடையாளர் முகவரி",
    "Receiver Name": "பெறுநரின் பெயர்",
    "Receiver Member Id": "பெறுநரின் உறுப்பினர் எண்",
    "Receiver Phone Number": "பெறுநரின் தொலைபேசி எண்",
    "Receiver Address": "பெறுநரின் முகவரி",
    "Blood Group": "குருதி வகை",
    "Add Blood Donation Details": "இரத்த தான விவரங்களை சேர்க்கவும்",
    "Sl. No": "வ.எண்",
    "Post Code": "அஞ்சல் குறியீடு",
    "Police Station": "காவல் நிலையம்",
    Taluk: "தாலுகா",
    "Create New": "புதிதாக உருவாக்கு",
    "Add Section Details": "பகுதி விவரங்களைச் சேர்க்கவும்",
    "Are you sure you want to deactivate?":
      "இதை செயலிழக்க செய்ய வேண்டும் என்பதில் உறுதியாக இருக்கிறீர்களா?",
    "Are you sure do you want to deactivate selected section?":
      "தேர்ந்தெடுக்கப்பட்ட பகுதியை செயலிழக்க செய்ய விரும்புகிறீர்களா?",
    "Are you sure do you want to delete selected section?":
      "தேர்ந்தெடுக்கப்பட்ட பகுதியை நீக்க விரும்புகிறீர்களா?",
    "Are you sure do you want to delete selected Survey?":
      "தேர்ந்தெடுக்கப்பட்ட கணக்கெடுப்யை நீக்க விரும்புகிறீர்களா?",
    "Are you sure do you want to delete selected App Questions?":
      "தேர்ந்தெடுக்கப்பட்ட விண்ணப்பக் கேள்விகளை நீக்க விரும்புகிறீர்களா?",
    "Are you sure do you want to delete selected Question Group?":
      "தேர்ந்தெடுக்கப்பட்ட கேள்விக் குழுவை நீக்க விரும்புகிறீர்களா?",
    "Are you sure do you want to delete selected Answer Group?":
      "தேர்ந்தெடுக்கப்பட்ட விடைக் குழுவை நீக்க விரும்புகிறீர்களா?",
    "App Question Title": "விண்ணப்பக் கேள்வி தலைப்பு",
    "Survey Title": "ஆய்வு தலைப்பு",
    "Submitted Survey": "சமர்ப்பிக்கப்பட்ட ஆய்வுகள்",
    "Quarterly report": "காலாண்டு அறிக்கை",
    "Select the constituency": "தொகுதியைத் தேர்வு செய்க",
    "Select the union": "ஒன்றியத்தை தேர்வு செய்க",
    Answers: "பதில்கள் ",
    "Add AppVersion": "செயலியின் பதிப்பை சேர்க்க",
    "App Version": "செயலியின் பதிப்பு",
    "App Version Code": "செயலியின் பதிப்பு குறியீடு",
    Platform: "இயங்குதளம்",
    "Release Notes": "வெளியீட்டு குறிப்புகள்",
    "Force Update": "கட்டாய புதுப்பிப்பு",
    android: "ஆண்ட்ராய்டு",
    ios: "ஐஒஸ",
    "Add Vacancy": "காலியிடத்தைச் சேர்க்க",
    "Update Vacancy": "காலியிடத்தை புதுப்பிக்க",
    "Delete Vacancy": "காலியிடத்தை நீக்க",
    Specifications: "விவரக்குறிப்புகள்",
    "Opening Date": "திறக்கும் தேதி",
    "Open Date": "ஆரம்பிக்கும் தேதி",
    "Completion Date": "நிறைவு தேதி",
    "Closing Date": "முடிக்கும் தேதி",
    "Decision Date": "இறுதித் தேதி",
    "To Apply": "விண்ணப்பிக்க",
    "You have no application to apply":
      "விண்ணப்பிக்க உங்களிடம் விண்ணப்பம் இல்லை",
    Latitude: "அட்சரேகை",
    Longtitude: "தீர்க்கரேகை",
    "Contact Person": "தொடர்பு கொள்ள வேண்டிய நபர்",
    "Contact Number": "தொலைபேசி எண்",
    "Add Address": "முகவரியைச் சேர்க்க",
    "Address Line 1": "முகவரி வரி 1",
    "Address Line 2": "முகவரி வரி 2",
    City: "நகரம்",
    "Control Name": "கட்டுப்பாட்டின் பெயர்",
    "View Access": "பார்வை அணுகல்",
    "Edit Access": "திருத்து அணுகல்",
    "Are you sure do you want to change the access?":
      "அணுகலை நிச்சயமாக மாற்ற விரும்புகிறீர்களா?",
    "No Data found": "தகவல்கள் எதுவும் இல்லை",
    "Incharge Id": "இன்சார்ஜ் ஐடி",
    "Please enter valid pincode": "சரியான அஞ்சல் குறியீடுயை  உள்ளிடவும்",
    "Please enter valid phone number": "சரியான தொலைபேசி எண்ணை உள்ளிடவும்",
    "I confirm that I have contacted him and verified the information":
      "இவரைத் தொடர்புக் கொண்டு தகவலை சரிபார்த்து விட்டேன் என்று உறுதி செய்கிறேன் ",
    "Are you sure you want to reject?":
      "நிச்சயமாக நிராகரிக்க விரும்புகிறீர்களா?",
    "Are you sure you want to nominate?":
      "நிச்சயமாக பரிந்துரைக்க விரும்புகிறீர்களா?",
  },
};
